import { N49 } from "./ComparativeMonthlySales/N49";
import { N63 } from "./ComparativeMonthlySalesDrugstoreChains/N63";
import { N42 } from "./ProductSalesGrowthPerformance/N42";
import { N64 } from "./ProductSalesByChannelPESO/N64";
import { N65 } from "./ProductSalesByCustomerGroupPESO/N65";

export const RegionComparativeSales = {
  "sections": [
    N49,
    N63,
    N42,
    N64,
    N65
  ]
}